import { Controller } from "@hotwired/stimulus"

// Sperrt das Element nach Klick für eine konfigurierbare Zeit (z. B. 800 ms).
// Optional: Element kann beim Erscheinen bereits gesperrt starten (startLocked).
// Nur für Todo Complete/Uncomplete-Buttons – andere Buttons nutzen weiterhin disable-on-click.
export default class extends Controller {
  static values = { lockDuration: { type: Number, default: 800 }, startLocked: Boolean }

  connect() {
    this._lockTimeoutId = null
    if (this.hasStartLockedValue && this.startLockedValue) {
      this._applyLock()
      this._scheduleUnlock()
    }
  }

  disconnect() {
    this._clearLockTimeout()
  }

  _clearLockTimeout() {
    if (this._lockTimeoutId != null) {
      clearTimeout(this._lockTimeoutId)
      this._lockTimeoutId = null
    }
  }

  _applyLock() {
    const el = this.element
    el.dataset.disabled = "true"
    el.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
  }

  _removeLock() {
    const el = this.element
    el.dataset.disabled = "false"
    el.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
  }

  _scheduleUnlock() {
    const ms = this.lockDurationValue > 0 ? this.lockDurationValue : 800
    this._clearLockTimeout()
    this._lockTimeoutId = setTimeout(() => {
      this._lockTimeoutId = null
      this._removeLock()
    }, ms)
  }

  disable(event) {
    if (this.element.dataset.disabled === "true") {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    this._applyLock()
    this._scheduleUnlock()
  }
}
